(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ioc-review-card"] && !Shopify.designMode) return;
  try {
    (function () {
    function fit(card) {
      var q = card.querySelector('[data-ioc-qcard-quote] p');
      if (!q) return;
      card.classList.toggle('is-fit', q.scrollHeight <= q.clientHeight + 2);
    }
    function run() {
      document.querySelectorAll('[data-ioc-qcard]').forEach(fit);
    }
    var t;
    function later() { clearTimeout(t); t = setTimeout(run, 150); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    window.addEventListener('load', run);
    window.addEventListener('resize', later);
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

})();
